import React from "react";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "src/utils/getImageUrl";
import { Ii18nInterpolationObject } from "src/@types/i18next";
import { CombinedMultiValueProps } from "./types";

export const MultiValue = ({
  children,
  data,
  removeProps,
}: CombinedMultiValueProps) => {
  const { t } = useTranslation();

  const valueLabel = children as Ii18nInterpolationObject | string;

  const label =
    typeof valueLabel === "string"
      ? valueLabel
      : t(valueLabel.i18nKey, valueLabel.i18nParams);

  return (
    <span
      {...removeProps}
      className="flex justify-center items-center gap-2 h-7.5 px-3 py-2 bg-purple-base text-white-base font-semibold rounded-20"
    >
      {data?.icon && (
        <img className="w-8" src={getImageUrl(data.icon)} alt={label} />
      )}
      <span> {label}</span>
    </span>
  );
};
